import { Loader2 } from 'lucide-react';

interface GeneratingPhotoPlaceholderProps {
    message?: string;
}

export function GeneratingPhotoPlaceholder({ message = 'Generowanie...' }: GeneratingPhotoPlaceholderProps) {
    return (
        <div
            className="relative overflow-hidden rounded-[6px] bg-gradient-to-br from-muted/50 to-muted border border-border shadow-sm w-full"
            style={{ aspectRatio: '16/10' }}
        >
            {/* Animated background shimmer */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-background/60 to-transparent animate-shimmer" />

            {/* Content */}
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
                <div className="w-14 h-14 rounded-full bg-card shadow-lg flex items-center justify-center">
                    <Loader2 className="w-7 h-7 text-muted-foreground animate-spin" strokeWidth={2} />
                </div>
                <div className="text-center">
                    <p className="text-[14px] font-medium text-foreground animate-pulse">
                        {message}
                    </p>
                    <p className="text-[12px] text-muted-foreground mt-0.5">
                        Proszę czekać...
                    </p>
                </div>
            </div>

            {/* Decorative corner accents */}
            <div className="absolute top-2 left-2 w-8 h-8 border-t-2 border-l-2 border-border/50 rounded-tl-md" />
            <div className="absolute bottom-2 right-2 w-8 h-8 border-b-2 border-r-2 border-border/50 rounded-br-md" />
        </div>
    );
}
